import '../../assets/components/Breadcrumb/breadcrumb.css';const d = "_breadcrumbContainer_1j6d2_1", n = "_breadcrumb_1j6d2_1", r = "_unsetPadding_1j6d2_37", e = {
  breadcrumbContainer: d,
  breadcrumb: n,
  unsetPadding: r
};
export {
  n as breadcrumb,
  d as breadcrumbContainer,
  e as default,
  r as unsetPadding
};
